import React from 'react';
import ArrowClockwise from '@uber/base-icons/arrow-clockwise';
import ChevronRight from '@uber/base-icons/chevron-right';
import { styled } from 'baseui';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { KIND as TAG_KIND, SIZE as TAG_SIZE, Tag } from 'baseui/tag';
import { LabelXSmall } from 'baseui/typography';
import { useSetAtom } from 'jotai';
import { completedAnnotationsAtom } from '../atoms';
import { REVIEW_ANNOTATION_STATUS, REVIEW_ANNOTATION_TYPE } from '../constants';
import { useReviewDrawer } from '../review-drawer';
import type { CompletedAnnotationT, ReviewAnnotationT } from '../types';
import { CardItem } from './card-item';
type Props = {
  annotation: ReviewAnnotationT & CompletedAnnotationT;
  selectAnnotation?: (annotationId: string) => void;
};
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `${$theme.sizing.scale0} solid ${$theme.colors.borderOpaque}`,
  borderRadius: $theme.borders.radius200,
  padding: $theme.sizing.scale500,
  gap: $theme.sizing.scale300,
  cursor: 'pointer'
}));
const Header = styled('div', () => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
}));
const Footer = styled('div', () => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
}));
export const CompletedCard = ({
  annotation: {
    annotationId,
    name,
    type,
    instances,
    status,
    attributes
  },
  selectAnnotation
}: Props) => {
  const {
    openObjectDetailsPanel
  } = useReviewDrawer();
  const setCompletedAnnotations = useSetAtom(completedAnnotationsAtom);
  const handleRevertToPending = () => {
    setCompletedAnnotations(prev => prev.filter(a => a.annotationId !== annotationId));
  };
  return <Container>
      <Header>
        <CardItem header="Annotation" content={name ?? annotationId} />
        <Button size={SIZE.mini} shape={SHAPE.circle} kind={KIND.tertiary} onClick={() => {
        openObjectDetailsPanel({
          annotationId,
          status
        }, handleRevertToPending);
        selectAnnotation?.(annotationId);
      }} data-testid="open-details-button">
          <ChevronRight />
        </Button>
      </Header>
      {type === REVIEW_ANNOTATION_TYPE.CLASSIFICATION ? <CardItem header="Questions"
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    content={(attributes?.[0].classificationAttributes?.length ?? 0).toString()} /> : <>
          {instances && instances.length > 0 && <CardItem header="Instances" content={instances.length.toString()} />}
          <CardItem header="Classification" content={instances && instances.length > 0 ? instances.map(i => `${i.startIndex} -> ${i.endIndex}`).join(', ') : '1'} />
        </>}
      <Footer>
        <Tag kind={status === REVIEW_ANNOTATION_STATUS.APPROVED ? TAG_KIND.positive : TAG_KIND.negative} closeable={false} size={TAG_SIZE.small} overrides={{
        Root: {
          style: {
            margin: 0
          }
        }
      }}>
          {status === REVIEW_ANNOTATION_STATUS.APPROVED ? 'Approved' : 'Rejected'}
        </Tag>
        <Button size={SIZE.mini} kind={KIND.secondary} startEnhancer={<ArrowClockwise />} onClick={handleRevertToPending}>
          <LabelXSmall>Revert to pending</LabelXSmall>
        </Button>
      </Footer>
    </Container>;
};